import { authHeader } from './auth-header';

export const userService = {
    login,
    logout,
    register,
    getAll,
    getCurrentUser,
};

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };

    return fetch(process.env.VUE_APP_URL+'api/login', requestOptions)
        .then(handleResponse)
        .then(user => {
            console.log(user);
            // login successful if there's a jwt token in the response
            if (user.result.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user.result));
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function getCurrentUser() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  return fetch(process.env.VUE_APP_URL + "api/user/profile", requestOptions)
    .then(handleResponse)
    .then((response) => {
      const freshUser = response?.result || null;
      const oldUser = JSON.parse(localStorage.getItem("user") || "{}");

      if (freshUser) {
        const mergedUser = {
          ...oldUser,
          ...freshUser,
          token: oldUser.token,
        };

        localStorage.setItem("user", JSON.stringify(mergedUser));
        return mergedUser;
      }

      return oldUser;
    });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
            }
            
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
